import React from 'react';
import { Outlet } from 'react-router-dom';

const ChatbotLayout = () => {
  return <Outlet />;
};

export default ChatbotLayout;
